// Bojan Nikolic <bojan@bnikolic.co.uk> 2019
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Card  from "react-bootstrap/Card";
import Form  from "react-bootstrap/Form";

import ReactMarkdown from "react-markdown";

import "./EQuestion.css";

// A question to be posed to the user. Description is in markdown.
export default class EQuestion extends Component {

  constructor(props) {
    super(props);
    this.cardDiv = React.createRef();
  }

  renderO(a) {
    return ( <Form.Check
	     type='checkbox'
 	     label={a}
	     onChange={e => this.props.hUpdate(this.props.ckey, a, e)}
	     />);
  }

  componentDidUpdate() {
    if (this.props.attent)
      this.cardDiv.current.scrollIntoView({behaviour: 'smooth'});
  }

  render() {

    return (
	<div ref={this.cardDiv}>
	<Card className={this.props.hi ? "highlight" : "" }
	     ref={this.props.ref}>
	     <Card.Body>
	     <ReactMarkdown source={this.props.content} />	     
	     <Form>
	     <Form.Group controlId={this.props.ckey}>
	     {this.props.options.map(this.renderO.bind(this))}
	     </Form.Group>
	     </Form>      
	     </Card.Body>	
	</Card>
    </div>);
  }
}

